import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 102,
	fill: "none",
	viewBox: "0 0 200 102",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#E5EBF5",
			stroke: "#fff",
			strokeWidth: 1.2,
			d: "M187.5 52.5v42.6c0 1.3-1.1 2.4-2.5 2.4H19.5c-1.3 0-2.4-1-2.4-2.4V54c0-1.3 1-2.4 2.4-2.4h86.3c.7 0 1.3-.3 1.8-.8L149 5c1-1.1 2.9-1 3.8.2L187 51c.3.5.5 1 .5 1.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m148.4 5.2 41.7 51c.2.2.5.4.9.4h6.4c1 0 1.6-1.2.9-2L153.6 1.8c-.4-.5-1-.6-1.5-.3l-3.4 1.9c-.6.4-.8 1.3-.3 1.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#B8AFB0",
			d: "m148.7 7.6 38.7 47.3c.3.3.6.5 1 .5h5.6c1 0 1.6-1.3 1-2l-42.3-50c-.5-.6-1.4-.6-1.9 0L148.7 6c-.4.5-.4 1.1 0 1.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0C3C36",
			d: "M137.7 60.9c0-.7.6-1.3 1.2-1.3h25c.7 0 1.3.6 1.3 1.3v36.6h-27.5V60.9Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#9B9293",
			d: "M133.4 22.4c-5 3.5-13.9 13-17.4 16.8L104.6 51a2 2 0 0 0 2.4 3l3.8-2.6 6.4-5.5.5-.6 3.3-5c0-.2.2-.4.4-.5l7.3-6.6.4-.5 3.6-5.4.5-.5 6.8-6 .4-.5 3.1-4.8.5-.6 4.8-3.9.5-.5 2.4-3.5c.7-1.1.4-2.6-1-2.7-.9 0-2.2.1-3.7.8-5.9 2.6.5 4.2-4.7 7.5s-3.9 6.2-9 9.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#9B9293",
			d: "M75 53.3c-7.3-1.3-23-1.5-29.4-1.5-3.8 0-15.6 2.1-22.3 3.4-1 .2-1 1.7 0 2h.4l6.4-1h.6l10 1h.6l7.5-1h.5l12.2 1h.5l8-1h.6l11.2 1h.6l7.2-1h.6l7.7 1h.6l5.6-.8c1.4-.1 2.2-1.4 1.2-2.4a9.6 9.6 0 0 0-3.6-2.2c-7.2-2.7-3.5 3.1-10.7 1.5-7.3-1.6-8.8 1.4-16 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m106.8 53.1 45.9-51.8-90.3 7.9c-5.6.5-10.9 2.9-14.9 6.8L10.3 52.2a1.8 1.8 0 0 0 1.3 3.1l93-1.1a3 3 0 0 0 2.2-1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#C3D0E6",
			fillOpacity: .3,
			d: "M71.4 48.5C63.4 47 46 46.9 39 46.9c-4.3 0-17.4 2.1-24.8 3.4-1 .2-1.1 1.8 0 2h.3l7.2-1h.6l11.3 1h.5l8.4-1h.5l13.6 1h.5l9-1h.6l12.6 1h.5l8-1h.6l8.7 1h.6l6.5-.8c1.3-.1 2.1-1.4 1.1-2.3-.8-.8-2-1.6-4-2.3-8-2.7-3.9 3.2-11.9 1.6-8-1.7-9.8 1.3-17.9 0Z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-9-inside-1_11964_15220",
			fill: "#fff",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 17.1,
				height: 20.8,
				x: 33.3,
				y: 60.9,
				rx: .6
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 17.1,
			height: 20.8,
			x: 33.3,
			y: 60.9,
			fill: "#FFDFA3",
			stroke: "#fff",
			strokeWidth: 3.7,
			mask: "url(#path-9-inside-1_11964_15220)",
			rx: .6
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-10-inside-2_11964_15220",
			fill: "#fff",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 17.1,
				height: 20.8,
				x: 76,
				y: 60.9,
				rx: .6
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 17.1,
			height: 20.8,
			x: 76,
			y: 60.9,
			fill: "#FFDFA3",
			stroke: "#fff",
			strokeWidth: 3.7,
			mask: "url(#path-10-inside-2_11964_15220)",
			rx: .6
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-11-inside-3_11964_15220",
			fill: "#fff",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 17.1,
				height: 20.8,
				x: 142,
				y: 24.8,
				rx: .6
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 17.1,
			height: 20.8,
			x: 142,
			y: 24.8,
			fill: "#FFDFA3",
			stroke: "#fff",
			strokeWidth: 3.7,
			mask: "url(#path-11-inside-3_11964_15220)",
			rx: .6
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeWidth: 1.8,
			d: "M42.1 80.4V62.7m6.4 8.8H33.9m51 8.9V62.7m6.4 8.8H76.6m73.6-27.1V26.7m7 8.8h-14.6"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 145.6,
			cy: 73.9,
			r: .9,
			fill: "#0F7166"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 145.5,
			cy: 72.3,
			r: 1.1,
			fill: "#0F7166"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 145.6,
			cy: 70.7,
			r: 1.1,
			fill: "#0F7166"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 146.3,
			cy: 69.3,
			r: .9,
			fill: "#0F7166"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 147.4,
			cy: 68,
			r: 1.1,
			fill: "#0F7166"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 149,
			cy: 67.3,
			r: 1.1,
			fill: "#0F7166"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: .9,
			cy: .9,
			r: .9,
			fill: "#0F7166",
			transform: "matrix(-1 0 0 1 158.2 73)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.1,
			cy: 1.1,
			r: 1.1,
			fill: "#0F7166",
			transform: "matrix(-1 0 0 1 158.5 71.1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.1,
			cy: 1.1,
			r: 1.1,
			fill: "#0F7166",
			transform: "matrix(-1 0 0 1 158.4 69.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: .9,
			cy: .9,
			r: .9,
			fill: "#0F7166",
			transform: "matrix(-1 0 0 1 157.5 68.3)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.1,
			cy: 1.1,
			r: 1.1,
			fill: "#0F7166",
			transform: "matrix(-1 0 0 1 156.6 66.9)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.1,
			cy: 1.1,
			r: 1.1,
			fill: "#0F7166",
			transform: "matrix(-1 0 0 1 155 66.1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: .9,
			cy: .9,
			r: .9,
			fill: "#0F7166",
			transform: "scale(-1 1) rotate(37.9 -172.6 -191)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.1,
			cy: 1.1,
			r: 1.1,
			fill: "#0F7166",
			transform: "scale(-1 1) rotate(37.9 -170.9 -189)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.1,
			cy: 1.1,
			r: 1.1,
			fill: "#0F7166",
			transform: "matrix(-.79 .614 .614 .79 150.4 65.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: .9,
			cy: .9,
			r: .9,
			fill: "#0F7166",
			transform: "matrix(1 0 0 -1 144.6 73)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.1,
			cy: 1.1,
			r: 1.1,
			fill: "#0F7166",
			transform: "matrix(1 0 0 -1 144.3 74.9)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.1,
			cy: 1.1,
			r: 1.1,
			fill: "#0F7166",
			transform: "matrix(1 0 0 -1 144.4 76.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: .9,
			cy: .9,
			r: .9,
			fill: "#0F7166",
			transform: "matrix(1 0 0 -1 145.4 77.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.1,
			cy: 1.1,
			r: 1.1,
			fill: "#0F7166",
			transform: "matrix(1 0 0 -1 146.3 79.1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.1,
			cy: 1.1,
			r: 1.1,
			fill: "#0F7166",
			transform: "matrix(1 0 0 -1 147.8 79.9)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 157.3,
			cy: 72.1,
			r: .9,
			fill: "#0F7166",
			transform: "rotate(180 157.3 72)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 157.3,
			cy: 73.7,
			r: 1.1,
			fill: "#0F7166",
			transform: "rotate(180 157.3 73.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 157.3,
			cy: 75.3,
			r: 1.1,
			fill: "#0F7166",
			transform: "rotate(180 157.3 75.3)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 156.5,
			cy: 76.7,
			r: .9,
			fill: "#0F7166",
			transform: "rotate(180 156.5 76.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 155.4,
			cy: 78,
			r: 1.1,
			fill: "#0F7166",
			transform: "rotate(180 155.4 78)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 153.9,
			cy: 78.7,
			r: 1.1,
			fill: "#0F7166",
			transform: "rotate(180 153.9 78.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 152,
			cy: 79.3,
			r: 1.1,
			fill: "#0F7166",
			transform: "rotate(-142 152 79.3)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 150.3,
			cy: 78.9,
			r: 1.1,
			fill: "#0F7166",
			transform: "rotate(-142 150.3 78.9)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 151.4,
			cy: 72.8,
			r: 4.6,
			stroke: "#0F7166",
			strokeWidth: 3.4
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 154.8,
			cy: 70.3,
			r: .9,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 147.8,
			cy: 75.8,
			r: .9,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 146.1,
			cy: 70.8,
			r: .9,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 149.2,
			cy: 68.3,
			r: .6,
			fill: "red"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 155.6,
			cy: 75.5,
			r: .6,
			fill: "red"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EC4949",
			fillRule: "evenodd",
			d: "M151.6 81c-1.5 0-4.4-.6-3.9-2.4.6-1.7 1.8-1.3 2.3-.8a4 4 0 0 1 1.6 3.2Zm-.5-.5c-.8 0-2.2-.3-1.9-1.2.2-.6 1-.3 1-.2.4.3.6.6 1 1.4Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EC4949",
			fillRule: "evenodd",
			d: "M151.3 81c.6-1.5 2-4.3 3.4-3.2 1.4 1.2.5 2.3 0 2.7-.6.4-2 1-3.4.5Zm.6-.4c.3-.7 1.3-1.8 1.9-1.5.6.4.2 1-.1 1.2-.3.2-1 .6-1.8.3Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EC4949",
			d: "M150.4 82.7c.3-.9.6-1.3 1.4-1.8l-.5-.2c-1 .3-1.3.6-1.9 1.4h.8l.2.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EC4949",
			d: "M152.7 82.8c-.3-1-.6-1.4-1.4-1.9l.5-.2c1 .3 1.3.6 2 1.5h-.9l-.2.6Z"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_f_11964_15220)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 16.9,
					cy: 57.2,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 21,
					cy: 56.4,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 18.7,
					cy: 56.2,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 19.6,
					cy: 57.9,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 22.2,
					cy: 57.7,
					r: .4,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 23.8,
					cy: 56.4,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 27.9,
					cy: 57.2,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 26.1,
					cy: 56.2,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 25.7,
					cy: 57.9,
					r: .6,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 29.6,
					cy: 56,
					r: .4,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 30.8,
					cy: 57.2,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 34.9,
					cy: 56.4,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 32.6,
					cy: 56.2,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 33.4,
					cy: 57.9,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 36.1,
					cy: 57.7,
					r: .4,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 37.7,
					cy: 56.4,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 41.8,
					cy: 57.2,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 40,
					cy: 56.2,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 39.6,
					cy: 57.9,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 43.5,
					cy: 56,
					r: .4,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 44.3,
					cy: 57.2,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 48.4,
					cy: 56.4,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 46.1,
					cy: 56.2,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 46.9,
					cy: 57.9,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 57.7,
					cy: 57.2,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 59.6,
					cy: 56.2,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 60.4,
					cy: 57.9,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 49.6,
					cy: 57.7,
					r: .4,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 51.2,
					cy: 56.4,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 55.3,
					cy: 57.2,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 53.5,
					cy: 56.2,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 53,
					cy: 57.9,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 56.9,
					cy: 56,
					r: .4,
					fill: "#FDC564"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_f_11964_15220)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 16.9,
					cy: 57.2,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 21,
					cy: 56.4,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 18.7,
					cy: 56.2,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 19.6,
					cy: 57.9,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 22.2,
					cy: 57.7,
					r: .4,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 23.8,
					cy: 56.4,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 27.9,
					cy: 57.2,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 26.1,
					cy: 56.2,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 25.7,
					cy: 57.9,
					r: .6,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 29.6,
					cy: 56,
					r: .4,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 30.8,
					cy: 57.2,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 34.9,
					cy: 56.4,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 32.6,
					cy: 56.2,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 33.4,
					cy: 57.9,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 36.1,
					cy: 57.7,
					r: .4,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 37.7,
					cy: 56.4,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 41.8,
					cy: 57.2,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 40,
					cy: 56.2,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 39.6,
					cy: 57.9,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 43.5,
					cy: 56,
					r: .4,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 44.3,
					cy: 57.2,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 48.4,
					cy: 56.4,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 46.1,
					cy: 56.2,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 46.9,
					cy: 57.9,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 57.7,
					cy: 57.2,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 59.6,
					cy: 56.2,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 60.4,
					cy: 57.9,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 49.6,
					cy: 57.7,
					r: .4,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 51.2,
					cy: 56.4,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 55.3,
					cy: 57.2,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 53.5,
					cy: 56.2,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 53,
					cy: 57.9,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 56.9,
					cy: 56,
					r: .4,
					fill: "#FDC564"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16.9,
			cy: 57.2,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 21,
			cy: 56.4,
			r: .8,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18.7,
			cy: 56.2,
			r: .6,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19.6,
			cy: 57.9,
			r: .6,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 22.2,
			cy: 57.7,
			r: .4,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 23.8,
			cy: 56.4,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 27.9,
			cy: 57.2,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 26.1,
			cy: 56.2,
			r: .6,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 25.7,
			cy: 57.9,
			r: .6,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 29.6,
			cy: 56,
			r: .4,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 30.8,
			cy: 57.2,
			r: .8,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 34.9,
			cy: 56.4,
			r: .8,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 32.6,
			cy: 56.2,
			r: .6,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 33.4,
			cy: 57.9,
			r: .6,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 36.1,
			cy: 57.7,
			r: .4,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 37.7,
			cy: 56.4,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 41.8,
			cy: 57.2,
			r: .8,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40,
			cy: 56.2,
			r: .6,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 39.6,
			cy: 57.9,
			r: .6,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 43.5,
			cy: 56,
			r: .4,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 44.3,
			cy: 57.2,
			r: .8,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 48.4,
			cy: 56.4,
			r: .8,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 46.1,
			cy: 56.2,
			r: .6,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 46.9,
			cy: 57.9,
			r: .6,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 57.7,
			cy: 57.2,
			r: .8,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 59.6,
			cy: 56.2,
			r: .6,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 60.4,
			cy: 57.9,
			r: .6,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 49.6,
			cy: 57.7,
			r: .4,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 51.2,
			cy: 56.4,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 55.3,
			cy: 57.2,
			r: .8,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 53.5,
			cy: 56.2,
			r: .6,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 53,
			cy: 57.9,
			r: .6,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 56.9,
			cy: 56,
			r: .4,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_f_11964_15220)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 61.2,
					cy: 56.7,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 65.3,
					cy: 55.9,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 63.1,
					cy: 55.7,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 63.9,
					cy: 57.3,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 66.5,
					cy: 57.1,
					r: .4,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 68.2,
					cy: 55.9,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 72.3,
					cy: 56.7,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 70.4,
					cy: 55.7,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 70,
					cy: 57.3,
					r: .6,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 73.9,
					cy: 55.5,
					r: .4,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 75.1,
					cy: 56.7,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 79.2,
					cy: 55.9,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 77,
					cy: 55.7,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 77.8,
					cy: 57.3,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 80.4,
					cy: 57.1,
					r: .4,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 82.1,
					cy: 55.9,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 86.1,
					cy: 56.7,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 84.3,
					cy: 55.7,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 83.9,
					cy: 57.3,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 87.8,
					cy: 55.5,
					r: .4,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 88.6,
					cy: 56.7,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 92.7,
					cy: 55.9,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 90.4,
					cy: 55.7,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 91.2,
					cy: 57.3,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 102.1,
					cy: 56.7,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 103.9,
					cy: 55.7,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 104.7,
					cy: 57.3,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 93.9,
					cy: 57.1,
					r: .4,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 95.5,
					cy: 55.9,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 99.6,
					cy: 56.7,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 97.8,
					cy: 55.7,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 97.4,
					cy: 57.3,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 101.3,
					cy: 55.5,
					r: .4,
					fill: "#FDC564"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter3_f_11964_15220)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 61.2,
					cy: 56.7,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 65.3,
					cy: 55.9,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 63.1,
					cy: 55.7,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 63.9,
					cy: 57.3,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 66.5,
					cy: 57.1,
					r: .4,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 68.2,
					cy: 55.9,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 72.3,
					cy: 56.7,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 70.4,
					cy: 55.7,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 70,
					cy: 57.3,
					r: .6,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 73.9,
					cy: 55.5,
					r: .4,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 75.1,
					cy: 56.7,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 79.2,
					cy: 55.9,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 77,
					cy: 55.7,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 77.8,
					cy: 57.3,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 80.4,
					cy: 57.1,
					r: .4,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 82.1,
					cy: 55.9,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 86.1,
					cy: 56.7,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 84.3,
					cy: 55.7,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 83.9,
					cy: 57.3,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 87.8,
					cy: 55.5,
					r: .4,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 88.6,
					cy: 56.7,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 92.7,
					cy: 55.9,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 90.4,
					cy: 55.7,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 91.2,
					cy: 57.3,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 102.1,
					cy: 56.7,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 103.9,
					cy: 55.7,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 104.7,
					cy: 57.3,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 93.9,
					cy: 57.1,
					r: .4,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 95.5,
					cy: 55.9,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 99.6,
					cy: 56.7,
					r: .8,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 97.8,
					cy: 55.7,
					r: .6,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 97.4,
					cy: 57.3,
					r: .6,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 101.3,
					cy: 55.5,
					r: .4,
					fill: "#FDC564"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 61.2,
			cy: 56.7,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 65.3,
			cy: 55.9,
			r: .8,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 63.1,
			cy: 55.7,
			r: .6,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 63.9,
			cy: 57.3,
			r: .6,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 66.5,
			cy: 57.1,
			r: .4,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 68.2,
			cy: 55.9,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 72.3,
			cy: 56.7,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 70.4,
			cy: 55.7,
			r: .6,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 70,
			cy: 57.3,
			r: .6,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 73.9,
			cy: 55.5,
			r: .4,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 75.1,
			cy: 56.7,
			r: .8,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 79.2,
			cy: 55.9,
			r: .8,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 77,
			cy: 55.7,
			r: .6,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 77.8,
			cy: 57.3,
			r: .6,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 80.4,
			cy: 57.1,
			r: .4,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 82.1,
			cy: 55.9,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 86.1,
			cy: 56.7,
			r: .8,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 84.3,
			cy: 55.7,
			r: .6,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 83.9,
			cy: 57.3,
			r: .6,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 87.8,
			cy: 55.5,
			r: .4,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 88.6,
			cy: 56.7,
			r: .8,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 92.7,
			cy: 55.9,
			r: .8,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 90.4,
			cy: 55.7,
			r: .6,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 91.2,
			cy: 57.3,
			r: .6,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 102.1,
			cy: 56.7,
			r: .8,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 103.9,
			cy: 55.7,
			r: .6,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 104.7,
			cy: 57.3,
			r: .6,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 93.9,
			cy: 57.1,
			r: .4,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 95.5,
			cy: 55.9,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 99.6,
			cy: 56.7,
			r: .8,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 97.8,
			cy: 55.7,
			r: .6,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 97.4,
			cy: 57.3,
			r: .6,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 101.3,
			cy: 55.5,
			r: .4,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter4_f_11964_15220)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 106.3,
					cy: 57.6,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 106.3 57.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 108.4,
					cy: 54,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 108.4 54)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 106.8,
					cy: 55.5,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 106.8 55.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 108.5,
					cy: 56,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 108.5 56)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 110.1,
					cy: 53.8,
					r: .4,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 110.1 53.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 110.3,
					cy: 51.8,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 110.3 51.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 113.6,
					cy: 49.3,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 113.6 49.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 111.6,
					cy: 50,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 111.6 50)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 112.6,
					cy: 51.4,
					r: .6,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 112.6 51.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 113.7,
					cy: 47.2,
					r: .4,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 113.7 47.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 115.5,
					cy: 47.1,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 115.5 47.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 117.5,
					cy: 43.5,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 117.5 43.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 115.9,
					cy: 45.1,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 116 45)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 117.7,
					cy: 45.5,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 117.7 45.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 119.3,
					cy: 43.4,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(-48.8 119.3 43.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 119.4,
					cy: 41.4,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 119.4 41.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 122.7,
					cy: 38.8,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 122.7 38.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 120.8,
					cy: 39.5,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 120.8 39.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 121.7,
					cy: 40.9,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 121.7 41)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 122.9,
					cy: 36.8,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(-48.8 122.9 36.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 124.3,
					cy: 37,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 124.3 37)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 126.4,
					cy: 33.4,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 126.4 33.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 124.8,
					cy: 34.9,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 124.8 35)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 126.5,
					cy: 35.4,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 126.5 35.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 133.2,
					cy: 26.8,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 133.2 26.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 133.7,
					cy: 24.8,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 133.7 24.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 135.4,
					cy: 25.3,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 135.4 25.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 128.1,
					cy: 33.3,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(-48.8 128.1 33.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 128.3,
					cy: 31.2,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 128.3 31.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 131.6,
					cy: 28.7,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 131.6 28.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 129.6,
					cy: 29.4,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 129.6 29.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 130.6,
					cy: 30.8,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 130.6 30.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 131.8,
					cy: 26.7,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(-48.8 131.8 26.7)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter5_f_11964_15220)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 106.3,
					cy: 57.6,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 106.3 57.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 108.4,
					cy: 54,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 108.4 54)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 106.8,
					cy: 55.5,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 106.8 55.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 108.5,
					cy: 56,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 108.5 56)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 110.1,
					cy: 53.8,
					r: .4,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 110.1 53.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 110.3,
					cy: 51.8,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 110.3 51.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 113.6,
					cy: 49.3,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 113.6 49.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 111.6,
					cy: 50,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 111.6 50)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 112.6,
					cy: 51.4,
					r: .6,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 112.6 51.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 113.7,
					cy: 47.2,
					r: .4,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 113.7 47.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 115.5,
					cy: 47.1,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 115.5 47.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 117.5,
					cy: 43.5,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 117.5 43.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 115.9,
					cy: 45.1,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 116 45)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 117.7,
					cy: 45.5,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 117.7 45.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 119.3,
					cy: 43.4,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(-48.8 119.3 43.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 119.4,
					cy: 41.4,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 119.4 41.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 122.7,
					cy: 38.8,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 122.7 38.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 120.8,
					cy: 39.5,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 120.8 39.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 121.7,
					cy: 40.9,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 121.7 41)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 122.9,
					cy: 36.8,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(-48.8 122.9 36.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 124.3,
					cy: 37,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 124.3 37)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 126.4,
					cy: 33.4,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 126.4 33.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 124.8,
					cy: 34.9,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 124.8 35)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 126.5,
					cy: 35.4,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 126.5 35.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 133.2,
					cy: 26.8,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 133.2 26.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 133.7,
					cy: 24.8,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 133.7 24.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 135.4,
					cy: 25.3,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 135.4 25.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 128.1,
					cy: 33.3,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(-48.8 128.1 33.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 128.3,
					cy: 31.2,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 128.3 31.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 131.6,
					cy: 28.7,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 131.6 28.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 129.6,
					cy: 29.4,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 129.6 29.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 130.6,
					cy: 30.8,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 130.6 30.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 131.8,
					cy: 26.7,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(-48.8 131.8 26.7)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 106.3,
			cy: 57.6,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(-48.8 106.3 57.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 108.4,
			cy: 54,
			r: .8,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 108.4 54)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 106.8,
			cy: 55.5,
			r: .6,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 106.8 55.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 108.5,
			cy: 56,
			r: .6,
			fill: "#FDC564",
			transform: "rotate(-48.8 108.5 56)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 110.1,
			cy: 53.8,
			r: .4,
			fill: "#FFF4E0",
			transform: "rotate(-48.8 110.1 53.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 110.3,
			cy: 51.8,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(-48.8 110.3 51.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 113.6,
			cy: 49.3,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(-48.8 113.6 49.3)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 111.6,
			cy: 50,
			r: .6,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 111.6 50)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 112.6,
			cy: 51.4,
			r: .6,
			fill: "#FFF4E0",
			transform: "rotate(-48.8 112.6 51.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 113.7,
			cy: 47.2,
			r: .4,
			fill: "#FFF4E0",
			transform: "rotate(-48.8 113.7 47.2)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 115.5,
			cy: 47.1,
			r: .8,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 115.5 47.1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 117.5,
			cy: 43.5,
			r: .8,
			fill: "#FFF4E0",
			transform: "rotate(-48.8 117.5 43.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 115.9,
			cy: 45.1,
			r: .6,
			fill: "#FDC564",
			transform: "rotate(-48.8 116 45)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 117.7,
			cy: 45.5,
			r: .6,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 117.7 45.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 119.3,
			cy: 43.4,
			r: .4,
			fill: "#FDC564",
			transform: "rotate(-48.8 119.3 43.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 119.4,
			cy: 41.4,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(-48.8 119.4 41.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 122.7,
			cy: 38.8,
			r: .8,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 122.7 38.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 120.8,
			cy: 39.5,
			r: .6,
			fill: "#FDC564",
			transform: "rotate(-48.8 120.8 39.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 121.7,
			cy: 40.9,
			r: .6,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 121.7 41)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 122.9,
			cy: 36.8,
			r: .4,
			fill: "#FDC564",
			transform: "rotate(-48.8 122.9 36.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 124.3,
			cy: 37,
			r: .8,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 124.3 37)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 126.4,
			cy: 33.4,
			r: .8,
			fill: "#FFF4E0",
			transform: "rotate(-48.8 126.4 33.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 124.8,
			cy: 34.9,
			r: .6,
			fill: "#FDC564",
			transform: "rotate(-48.8 124.8 35)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 126.6,
			cy: 35.4,
			r: .6,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 126.6 35.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 133.2,
			cy: 26.8,
			r: .8,
			fill: "#FFF4E0",
			transform: "rotate(-48.8 133.2 26.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 133.7,
			cy: 24.8,
			r: .6,
			fill: "#FDC564",
			transform: "rotate(-48.8 133.7 24.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 135.4,
			cy: 25.3,
			r: .6,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 135.4 25.3)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 128.2,
			cy: 33.3,
			r: .4,
			fill: "#FDC564",
			transform: "rotate(-48.8 128.2 33.3)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 128.3,
			cy: 31.2,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(-48.8 128.3 31.2)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 131.6,
			cy: 28.7,
			r: .8,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 131.6 28.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 129.6,
			cy: 29.4,
			r: .6,
			fill: "#FDC564",
			transform: "rotate(-48.8 129.6 29.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 130.6,
			cy: 30.8,
			r: .6,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 130.6 30.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 131.8,
			cy: 26.7,
			r: .4,
			fill: "#FDC564",
			transform: "rotate(-48.8 131.8 26.7)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter6_f_11964_15220)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 136.4,
					cy: 22.6,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 136.4 22.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 138.5,
					cy: 19,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 138.5 19)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 136.9,
					cy: 20.6,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 136.9 20.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 138.6,
					cy: 21,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 138.6 21)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 140.2,
					cy: 18.9,
					r: .4,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 140.2 18.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 140.4,
					cy: 16.9,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 140.4 16.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 143.7,
					cy: 14.3,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 143.7 14.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 141.7,
					cy: 15,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 141.7 15)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 142.7,
					cy: 16.4,
					r: .6,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 142.7 16.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 143.9,
					cy: 12.3,
					r: .4,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 143.9 12.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 145.6,
					cy: 12.2,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 145.6 12.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 147.7,
					cy: 8.6,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 147.7 8.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 146,
					cy: 10.1,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 146 10.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 147.8,
					cy: 10.6,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 147.8 10.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 149.4,
					cy: 8.5,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(-48.8 149.4 8.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 149.5,
					cy: 6.4,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 149.5 6.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 152.8,
					cy: 3.9,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 152.8 3.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 150.9,
					cy: 4.6,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 150.9 4.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 151.8,
					cy: 6,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 151.8 6)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter7_f_11964_15220)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 136.4,
					cy: 22.6,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 136.4 22.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 138.5,
					cy: 19,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 138.5 19)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 136.9,
					cy: 20.6,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 136.9 20.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 138.6,
					cy: 21,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 138.6 21)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 140.2,
					cy: 18.9,
					r: .4,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 140.2 18.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 140.4,
					cy: 16.9,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 140.4 16.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 143.7,
					cy: 14.3,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 143.7 14.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 141.7,
					cy: 15,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 141.7 15)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 142.7,
					cy: 16.4,
					r: .6,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 142.7 16.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 143.9,
					cy: 12.3,
					r: .4,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 143.9 12.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 145.6,
					cy: 12.2,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 145.6 12.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 147.7,
					cy: 8.6,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 147.7 8.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 146,
					cy: 10.1,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 146 10.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 147.8,
					cy: 10.6,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 147.8 10.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 149.4,
					cy: 8.5,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(-48.8 149.4 8.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 149.5,
					cy: 6.4,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 149.5 6.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 150.9,
					cy: 4.6,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(-48.8 150.9 4.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 151.8,
					cy: 6,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 151.8 6)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 149.5,
			cy: 6.4,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(-48.8 149.5 6.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 150.9,
			cy: 4.6,
			r: .6,
			fill: "#FDC564",
			transform: "rotate(-48.8 150.9 4.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 151.8,
			cy: 6,
			r: .6,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 151.8 6)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter8_f_11964_15220)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 152.8,
					cy: 5.8,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 152.8 5.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 156,
					cy: 8.4,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(50.6 156 8.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 154.7,
					cy: 6.5,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 154.7 6.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 154,
					cy: 8.2,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(50.6 154 8.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 155.8,
					cy: 10.1,
					r: .4,
					fill: "#FFF4E0",
					transform: "rotate(50.6 155.8 10.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 157.8,
					cy: 10.6,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 157.8 10.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 159.8,
					cy: 14.3,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 159.8 14.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 159.4,
					cy: 12.2,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 159.4 12.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 157.9,
					cy: 13,
					r: .6,
					fill: "#FFF4E0",
					transform: "rotate(50.6 157.9 13)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 161.7,
					cy: 14.8,
					r: .4,
					fill: "#FFF4E0",
					transform: "rotate(50.6 161.7 14.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 161.6,
					cy: 16.5,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(50.6 161.6 16.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 164.8,
					cy: 19.1,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(50.6 164.8 19.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 163.5,
					cy: 17.3,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(50.6 163.5 17.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 162.8,
					cy: 18.9,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 162.8 19)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 164.6,
					cy: 20.9,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(50.6 164.6 20.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 166.6,
					cy: 21.4,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 166.6 21.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 168.6,
					cy: 25,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(50.6 168.6 25)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 168.2,
					cy: 23,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(50.6 168.2 23)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 166.7,
					cy: 23.7,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 166.7 23.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 170.6,
					cy: 25.5,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(50.6 170.6 25.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 170.1,
					cy: 26.9,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(50.6 170.1 27)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 173.4,
					cy: 29.6,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(50.6 173.4 29.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 172.1,
					cy: 27.7,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(50.6 172 27.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 171.3,
					cy: 29.4,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 171.3 29.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 178.7,
					cy: 37.3,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(50.6 178.7 37.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 180.6,
					cy: 38.1,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(50.6 180.6 38.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 179.9,
					cy: 39.8,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 179.9 39.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 173.2,
					cy: 31.3,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(50.6 173.2 31.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 175.2,
					cy: 31.8,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 175.2 31.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 177.1,
					cy: 35.4,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(50.6 177.1 35.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 176.8,
					cy: 33.4,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(50.6 176.8 33.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 175.2,
					cy: 34.1,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 175.2 34.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 179.1,
					cy: 35.9,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(50.6 179.1 36)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter9_f_11964_15220)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 152.8,
					cy: 5.8,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 152.8 5.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 156,
					cy: 8.4,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(50.6 156 8.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 154.7,
					cy: 6.5,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 154.7 6.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 154,
					cy: 8.2,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(50.6 154 8.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 155.8,
					cy: 10.1,
					r: .4,
					fill: "#FFF4E0",
					transform: "rotate(50.6 155.8 10.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 157.8,
					cy: 10.6,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 157.8 10.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 159.8,
					cy: 14.3,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 159.8 14.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 159.4,
					cy: 12.2,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 159.4 12.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 157.9,
					cy: 13,
					r: .6,
					fill: "#FFF4E0",
					transform: "rotate(50.6 157.9 13)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 161.7,
					cy: 14.8,
					r: .4,
					fill: "#FFF4E0",
					transform: "rotate(50.6 161.7 14.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 161.6,
					cy: 16.5,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(50.6 161.6 16.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 164.8,
					cy: 19.1,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(50.6 164.8 19.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 163.5,
					cy: 17.3,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(50.6 163.5 17.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 162.8,
					cy: 18.9,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 162.8 19)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 164.6,
					cy: 20.9,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(50.6 164.6 20.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 166.6,
					cy: 21.4,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 166.6 21.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 168.6,
					cy: 25,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(50.6 168.6 25)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 168.2,
					cy: 23,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(50.6 168.2 23)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 166.7,
					cy: 23.7,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 166.7 23.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 170.6,
					cy: 25.5,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(50.6 170.6 25.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 170.1,
					cy: 26.9,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(50.6 170.1 27)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 173.4,
					cy: 29.6,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(50.6 173.4 29.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 172.1,
					cy: 27.7,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(50.6 172 27.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 171.3,
					cy: 29.4,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 171.3 29.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 178.7,
					cy: 37.3,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(50.6 178.7 37.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 180.6,
					cy: 38.1,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(50.6 180.6 38.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 179.9,
					cy: 39.8,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 179.9 39.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 173.2,
					cy: 31.3,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(50.6 173.2 31.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 175.2,
					cy: 31.8,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 175.2 31.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 177.1,
					cy: 35.4,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(50.6 177.1 35.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 176.8,
					cy: 33.4,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(50.6 176.8 33.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 175.2,
					cy: 34.1,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 175.2 34.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 179.1,
					cy: 35.9,
					r: .4,
					fill: "#FDC564",
					transform: "rotate(50.6 179.1 36)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 152.8,
			cy: 5.8,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(50.6 152.8 5.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 156,
			cy: 8.4,
			r: .8,
			fill: "#FFDFA2",
			transform: "rotate(50.6 156 8.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 154.7,
			cy: 6.5,
			r: .6,
			fill: "#FFDFA2",
			transform: "rotate(50.6 154.7 6.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 154,
			cy: 8.2,
			r: .6,
			fill: "#FDC564",
			transform: "rotate(50.6 154 8.2)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 155.8,
			cy: 10.1,
			r: .4,
			fill: "#FFF4E0",
			transform: "rotate(50.6 155.8 10.1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 157.8,
			cy: 10.6,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(50.6 157.8 10.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 159.8,
			cy: 14.3,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(50.6 159.8 14.3)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 159.4,
			cy: 12.2,
			r: .6,
			fill: "#FFDFA2",
			transform: "rotate(50.6 159.4 12.2)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 157.9,
			cy: 12.9,
			r: .6,
			fill: "#FFF4E0",
			transform: "rotate(50.6 157.9 13)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 161.7,
			cy: 14.8,
			r: .4,
			fill: "#FFF4E0",
			transform: "rotate(50.6 161.7 14.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 161.6,
			cy: 16.5,
			r: .8,
			fill: "#FFDFA2",
			transform: "rotate(50.6 161.6 16.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 164.8,
			cy: 19.1,
			r: .8,
			fill: "#FFF4E0",
			transform: "rotate(50.6 164.8 19.1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 163.5,
			cy: 17.3,
			r: .6,
			fill: "#FDC564",
			transform: "rotate(50.6 163.5 17.3)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 162.8,
			cy: 18.9,
			r: .6,
			fill: "#FFDFA2",
			transform: "rotate(50.6 162.8 19)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 164.6,
			cy: 20.9,
			r: .4,
			fill: "#FDC564",
			transform: "rotate(50.6 164.6 20.9)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 166.6,
			cy: 21.4,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(50.6 166.6 21.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 168.6,
			cy: 25,
			r: .8,
			fill: "#FFDFA2",
			transform: "rotate(50.6 168.6 25)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 168.2,
			cy: 23,
			r: .6,
			fill: "#FDC564",
			transform: "rotate(50.6 168.2 23)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 166.7,
			cy: 23.7,
			r: .6,
			fill: "#FFDFA2",
			transform: "rotate(50.6 166.7 23.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 170.6,
			cy: 25.5,
			r: .4,
			fill: "#FDC564",
			transform: "rotate(50.6 170.6 25.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 170.1,
			cy: 26.9,
			r: .8,
			fill: "#FFDFA2",
			transform: "rotate(50.6 170.1 27)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 173.4,
			cy: 29.6,
			r: .8,
			fill: "#FFF4E0",
			transform: "rotate(50.6 173.4 29.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 172.1,
			cy: 27.7,
			r: .6,
			fill: "#FDC564",
			transform: "rotate(50.6 172 27.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 171.3,
			cy: 29.4,
			r: .6,
			fill: "#FFDFA2",
			transform: "rotate(50.6 171.3 29.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 178.7,
			cy: 37.3,
			r: .8,
			fill: "#FFF4E0",
			transform: "rotate(50.6 178.7 37.3)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 180.6,
			cy: 38.1,
			r: .6,
			fill: "#FDC564",
			transform: "rotate(50.6 180.6 38.1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 179.9,
			cy: 39.8,
			r: .6,
			fill: "#FFDFA2",
			transform: "rotate(50.6 179.9 39.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 173.2,
			cy: 31.3,
			r: .4,
			fill: "#FDC564",
			transform: "rotate(50.6 173.2 31.3)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 175.2,
			cy: 31.8,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(50.6 175.2 31.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 177.1,
			cy: 35.4,
			r: .8,
			fill: "#FFDFA2",
			transform: "rotate(50.6 177.1 35.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 176.8,
			cy: 33.4,
			r: .6,
			fill: "#FDC564",
			transform: "rotate(50.6 176.8 33.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 175.2,
			cy: 34.1,
			r: .6,
			fill: "#FFDFA2",
			transform: "rotate(50.6 175.2 34)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 179.1,
			cy: 35.9,
			r: .4,
			fill: "#FDC564",
			transform: "rotate(50.6 179.1 36)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter10_f_11964_15220)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 182.3,
					cy: 41.2,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 182.3 41.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 185.6,
					cy: 43.8,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(50.6 185.6 43.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 184.3,
					cy: 42,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 184.3 42)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 183.5,
					cy: 43.6,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(50.6 183.5 43.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 185.4,
					cy: 45.5,
					r: .4,
					fill: "#FFF4E0",
					transform: "rotate(50.6 185.4 45.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 187.4,
					cy: 46,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 187.4 46)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 189.3,
					cy: 49.7,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 189.3 49.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 189,
					cy: 47.6,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 189 47.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 187.4,
					cy: 48.4,
					r: .6,
					fill: "#FFF4E0",
					transform: "rotate(50.6 187.4 48.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 191.3,
					cy: 50.2,
					r: .4,
					fill: "#FFF4E0",
					transform: "rotate(50.6 191.3 50.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 191.1,
					cy: 51.9,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(50.6 191.1 52)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 194.4,
					cy: 54.6,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(50.6 194.4 54.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 193.1,
					cy: 52.7,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(50.6 193.1 52.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 192.4,
					cy: 54.4,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 192.4 54.4)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter11_f_11964_15220)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 182.3,
					cy: 41.2,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 182.3 41.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 185.6,
					cy: 43.8,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(50.6 185.6 43.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 184.3,
					cy: 42,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 184.3 42)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 183.5,
					cy: 43.6,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(50.6 183.5 43.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 185.4,
					cy: 45.5,
					r: .4,
					fill: "#FFF4E0",
					transform: "rotate(50.6 185.4 45.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 187.4,
					cy: 46,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 187.4 46)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 189.3,
					cy: 49.7,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 189.3 49.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 189,
					cy: 47.6,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 189 47.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 187.4,
					cy: 48.4,
					r: .6,
					fill: "#FFF4E0",
					transform: "rotate(50.6 187.4 48.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 191.3,
					cy: 50.2,
					r: .4,
					fill: "#FFF4E0",
					transform: "rotate(50.6 191.3 50.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 191.1,
					cy: 51.9,
					r: .8,
					fill: "#FFDFA2",
					transform: "rotate(50.6 191.1 52)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 194.4,
					cy: 54.6,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(50.6 194.4 54.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 193.1,
					cy: 52.7,
					r: .6,
					fill: "#FDC564",
					transform: "rotate(50.6 193.1 52.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 192.4,
					cy: 54.4,
					r: .6,
					fill: "#FFDFA2",
					transform: "rotate(50.6 192.4 54.4)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M56.8 89.2c-16.3-1-26.7-1.8-41.7 4.1C8.8 95.8 0 101.5 0 101.5h200s-49.6-5-60-6.3c-16.2-1.9-26.9-.7-43.2-1.9-16.6-1.1-23.4-3.2-40-4.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			stroke: "#fff",
			strokeWidth: 1.5,
			d: "M85 3v11.6a2 2 0 0 0 1.2 1.9l4 1.9a2 2 0 0 0 2.3-.3l6.2-5.7c.5-.4.7-1 .7-1.5V3a2 2 0 0 0-2-2.1H87A2 2 0 0 0 85 3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#320009",
			d: "M91.2 2.5c0-.5.4-1 1-1h5.1c.6 0 1 .5 1 1v8.6c0 .3 0 .6-.2.7l-5.2 5a1 1 0 0 1-1.7-.7V2.5Z"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_11964_15220",
				width: 46.6,
				height: 4.5,
				x: 15.3,
				y: 54.8,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_15220",
						stdDeviation: .4
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_f_11964_15220",
				width: 46.6,
				height: 4.5,
				x: 15.3,
				y: 54.8,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_15220",
						stdDeviation: .4
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_f_11964_15220",
				width: 46.6,
				height: 4.5,
				x: 59.6,
				y: 54.3,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_15220",
						stdDeviation: .4
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_f_11964_15220",
				width: 46.6,
				height: 4.5,
				x: 59.6,
				y: 54.3,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_15220",
						stdDeviation: .4
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter4_f_11964_15220",
				width: 32.2,
				height: 35.8,
				x: 104.7,
				y: 23.4,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_15220",
						stdDeviation: .4
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter5_f_11964_15220",
				width: 32.2,
				height: 35.8,
				x: 104.7,
				y: 23.4,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_15220",
						stdDeviation: .4
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter6_f_11964_15220",
				width: 19.7,
				height: 22,
				x: 134.8,
				y: 2.3,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_15220",
						stdDeviation: .4
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter7_f_11964_15220",
				width: 18.5,
				height: 21.1,
				x: 134.8,
				y: 3.2,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_15220",
						stdDeviation: .4
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter8_f_11964_15220",
				width: 30.9,
				height: 37.1,
				x: 151.1,
				y: 4.1,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_15220",
						stdDeviation: .4
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter9_f_11964_15220",
				width: 30.9,
				height: 37.1,
				x: 151.1,
				y: 4.1,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_15220",
						stdDeviation: .4
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter10_f_11964_15220",
				width: 15.3,
				height: 16.6,
				x: 180.7,
				y: 39.5,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_15220",
						stdDeviation: .4
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter11_f_11964_15220",
				width: 15.3,
				height: 16.6,
				x: 180.7,
				y: 39.5,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_15220",
						stdDeviation: .4
					})
				]
			})
		] })
	]
});
const SvgWhiteHouse = styled(base)({});
export default SvgWhiteHouse;
